import React from 'react';
import ReviewHeader from '../../../review/reviewHeader/ReviewHeader';
import styles from './SupportHeader.module.scss';
import {
  supportHeaderDesktop,
  supportHeaderTab,
} from '../../../../../src/images';

const SupportHeader = () => {
  const HeroContent = {
    img: {
      small: supportHeaderTab,
      medium: supportHeaderTab,
      large: supportHeaderDesktop,
    },
    subTitle: 'Support Center',
    mainTitle: `${"You've Got Questions? We've Got Answers."}`,
  };
  return (
    <>
      <ReviewHeader
        content={HeroContent}
        isDarkNav={true}
        darkContent={false}
        className={styles.supportHeader}
      />
    </>
  );
};

export default SupportHeader;
